import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Login from '../../components/auth/Login';
import { useAuth } from '../../context/AuthContext';
import { authApi } from '../../api/authApi';

const LoginPage = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [forcePasswordChange, setForcePasswordChange] = useState(false);
    const [tempUser, setTempUser] = useState(null);

    const handleLoginSubmit = async (username, password) => {
        setError('');
        setLoading(true);

        try {
            const data = await authApi.login(username, password);

            if (data.user.password_change_required) {
                setForcePasswordChange(true);
                setTempUser(data.user);
                localStorage.setItem('token', data.token);
            } else {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                login(data.user);
                navigate('/');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login fehlgeschlagen');
        } finally {
            setLoading(false);
        }
    };

    const handleChangePasswordSubmit = async (newPassword) => {
        setError('');
        setLoading(true);

        try {
            const data = await authApi.changeRequiredPassword(newPassword);

            localStorage.setItem('user', JSON.stringify(data.user));
            setForcePasswordChange(false);
            setTempUser(null);
            login(data.user);
            navigate('/');
        } catch (err) {
            setError(err.response?.data?.error || 'Fehler beim Ändern des Passworts');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Login
            onLoginSubmit={handleLoginSubmit}
            onChangePasswordSubmit={handleChangePasswordSubmit}
            error={error}
            setError={setError}
            loading={loading}
            forcePasswordChange={forcePasswordChange}
            tempUser={tempUser}
        />
    );
};

export default LoginPage;
